import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Tag } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "hint"
    }}>{`Hint`}</h1>
    <h3 {...{
      "id": "usage"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tag } from '@nejcm/docz-theme-extended';
`}</code></pre>
    <hr />
    <h3 {...{
      "id": "types"
    }}>{`Types`}</h3>
    <Playground __position={1} __code={'<Tag>default</Tag>\n<br />\n<Tag type=\"info\">info</Tag>\n<br />\n<Tag type=\"warning\">warning</Tag>\n<br />\n<Tag type=\"danger\">danger</Tag>\n<br />\n<Tag type=\"success\">success</Tag>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Tag,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Tag mdxType="Tag">default</Tag>
  <br />
  <Tag type="info" mdxType="Tag">info</Tag>
  <br />
  <Tag type="warning" mdxType="Tag">warning</Tag>
  <br />
  <Tag type="danger" mdxType="Tag">danger</Tag>
  <br />
  <Tag type="success" mdxType="Tag">success</Tag>
    </Playground>
    <h3 {...{
      "id": "sizes"
    }}>{`Sizes`}</h3>
    <Playground __position={2} __code={'<Tag size=\"small\">small</Tag>\n<br />\n<Tag>default</Tag>\n<br />\n<Tag size=\"medium\">medium</Tag>\n<br />\n<Tag size=\"large\">large</Tag>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Tag,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Tag size="small" mdxType="Tag">small</Tag>
  <br />
  <Tag mdxType="Tag">default</Tag>
  <br />
  <Tag size="medium" mdxType="Tag">medium</Tag>
  <br />
  <Tag size="large" mdxType="Tag">large</Tag>
    </Playground>
    <h3 {...{
      "id": "radius"
    }}>{`Radius`}</h3>
    <Playground __position={3} __code={'<Tag radius={10}> 10 = 10px </Tag>\n<br />\n<Tag radius=\"1em\"> 1em </Tag>\n<br />\n<Tag radius={0}> 0 </Tag>\n<br />\n<Tag radius=\"3px\"> 3px </Tag>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Tag,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Tag radius={10} mdxType="Tag"> 10 = 10px </Tag>
  <br />
  <Tag radius="1em" mdxType="Tag"> 1em </Tag>
  <br />
  <Tag radius={0} mdxType="Tag"> 0 </Tag>
  <br />
  <Tag radius="3px" mdxType="Tag"> 3px </Tag>
    </Playground>
    <h3 {...{
      "id": "custom"
    }}>{`Custom`}</h3>
    <Playground __position={4} __code={'<Tag circle type=\"danger\">\n  3\n</Tag>\n<br />\n<Tag circle type=\"success\">\n  <small>+99</small>\n</Tag>\n<br />\n<Tag circle size=\"large\" type=\"warning\">\n  <strong>1</strong>\n</Tag>\n<br />\n<Tag style={{ backgroundColor: \'#333\' }}>\n  📦 <strong>with icon and custom bg color</strong>\n</Tag>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Tag,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Tag circle type="danger" mdxType="Tag">
    3
  </Tag>
  <br />
  <Tag circle type="success" mdxType="Tag">
    <small>+99</small>
  </Tag>
  <br />
  <Tag circle size="large" type="warning" mdxType="Tag">
    <strong>1</strong>
  </Tag>
  <br />
  <Tag style={{
        backgroundColor: '#333'
      }} mdxType="Tag">
    📦 <strong>with icon and custom bg color</strong>
  </Tag>
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <Props table={true} of={Tag} mdxType="Props" />
    <hr />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      